import { render, staticRenderFns } from "./affiliateListAdmin.vue?vue&type=template&id=1fd5f762&lang=pug"
import script from "./affiliateListAdmin.vue?vue&type=script&lang=js"
export * from "./affiliateListAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports